import React, { useEffect, FC } from 'react'

import Loading from '../components/system/Loading'

// The password reset request form moved to app2. The emailed link still lands
// on the legacy /settings?token= page, which this change leaves alone.
const TO = '/v2/forgot-password'

const ResetPassword: FC<React.PropsWithChildren<unknown>> = () => {
  useEffect(() => {
    window.location.replace(TO)
  }, [])

  return <Loading />
}

export default ResetPassword
